"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Notifications = {
  page: 2,
  onload: document.addEventListener('DOMContentLoaded', function () {
    Notifications.init();
  }),
  init: function init() {
    this.bind();
  },
  bind: function bind() {
    $(document).on('click', '.remove-notification', function (event) {
      event.preventDefault();
      Notifications.collectionData();
      var ids = $('.get-json').val();
      Notifications.ajax.removeNotifications(ids);
    }).on('click', '.mark-as-important', function (event) {
      event.preventDefault();
      Notifications.collectionData();
      var ids = $('.get-json').val();
      Notifications.ajax.markAsImportant(ids);
    }).on('click', '.mark-as-read', function (event) {
      event.preventDefault();
      Notifications.collectionData();
      var ids = $('.get-json').val();
      Notifications.ajax.markAsRead(ids);
    }).on('click', '.mark-as-important-one-notification', function (event) {
      event.preventDefault();
      var id = $(this).closest('.messages__item').attr('data-hash');
      Notifications.ajax.markAsImportantOneNotification(id);
    }).on('click', '.mark-as-not-important', function (event) {
      event.preventDefault();
      var id = $(this).closest('.messages__item').attr('data-hash');
      Notifications.ajax.markAsNotImportant(id);
    }).on('change', '.all-select-item', function (event) {
      var checkElement = $('.all-select-checked');
      if ($(this).find('input').is(':checked')) {
        checkElement.find('input').prop("checked", true);
        checkElement.find('.avatar-icon').addClass('active');
        checkElement.find('.messages__item').addClass('active');
        $('.notifications-nav__items').addClass('active');
      } else {
        checkElement.find('input').prop("checked", false);
        checkElement.find('.avatar-icon').removeClass('active');
        checkElement.find('.messages__item').removeClass('active');
        $('.notifications-nav__items').removeClass('active');
      }
    }).on('change', '.checked-block', function () {
      var checkElement = $('.all-select-checked');
      $('.all-select-item').find('input').prop('checked', false);
      if (checkElement.find('input').is(':checked')) {
        $(this).closest('.messages__item').addClass('active');
        $('.notifications-nav__items').addClass('active');
        $(this).closest('.messages__item').find('.avatar-icon').addClass('active');
      } else {
        $(this).closest('.messages__item').removeClass('active');
        $('.notifications-nav__items').removeClass('active');
        $(this).closest('.messages__item').find('.avatar-icon').removeClass('active');
      }
    }).on('click', '#load_more_notifications', function () {
      Main.showPreloader($(this));
      Notifications.ajax.nextPage($(this));
    });
  },
  collectionData: function collectionData() {
    var inputGetJson = $('.get-json');
    var checkbox = $('.all-select-checked').find("input:checked");
    var searchIDs = [];
    checkbox.map(function () {
      searchIDs.push($(this).closest('.messages__item').attr('data-hash'));
    });
    var json = _objectSpread({}, searchIDs);
    inputGetJson.val(checkbox.length > 0 ? JSON.stringify(json) : '');
  },
  receiveNotification: function receiveNotification(data) {
    Messages.playSoundWhenUserReceivedMessage();
    Notify.successfulNotification(data.text);
  },
  ajax: {
    obj: {},
    url: USER_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    nextPage: function nextPage(button) {
      this.obj.method = 'nextPage';
      this.obj.category = button.attr('data-category');
      this.obj.filter = button.attr('data-filter');
      this.obj.page = button.attr('data-page');
      this.send(function (answer) {
        ++Notifications.page;
        button.attr('data-page', Notifications.page);
        $('.messages__items').append(answer.html);
        if (answer.notificationsCount < 10) {
          button.hide();
        }
        Main.hidePreloader(button);
      }, function (answer) {
        button.hide();
        Main.hidePreloader(button);
      });
    },
    markAsRead: function markAsRead(ids) {
      this.obj.method = 'markAsRead';
      this.obj.ids = ids;
      this.send(function (answer) {
        location.reload();
      }, function (answer) {
        // Notify.dangerNotification(answer.text);
      });
    },
    markAsImportantOneNotification: function markAsImportantOneNotification(id) {
      this.obj.method = 'markAsImportantOneNotification';
      this.obj.id = id;
      this.send(function (answer) {
        location.reload();
      }, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    markAsNotImportant: function markAsNotImportant(id) {
      this.obj.method = 'markAsNotImportant';
      this.obj.id = id;
      this.send(function (answer) {
        location.reload();
      }, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    markAsImportant: function markAsImportant(ids) {
      this.obj.method = 'markAsImportant';
      this.obj.ids = ids;
      this.send(function (answer) {
        location.reload();
      }, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    removeNotifications: function removeNotifications(ids) {
      this.obj.method = 'removeNotifications';
      this.obj.ids = ids;
      this.send(function (answer) {
        location.reload();
      }, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    }
  }
};